module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-hyundai.9e56b51b.png";